import React, { useState, useEffect } from "react";
import "./ImageGalleryPopup.scss";
import { left, galleryclose } from "../../Helpers/Images";
import OwlCarousel from "react-owl-carousel2";
import { mediaUrl, apiglobaltixMediaUrl } from "../../Helpers/Config";

const ImageGalleryPopup = (props) => {
  const { open, handleClose, isMobile, productDetail, showGalleryFor } = props;
  const [selectedImage, setSelectedImage] = useState(0);
  const [imagesArray, setImagesArray] = useState([]);
  const carousel = {
    items: 1,
    loop: true,
    dots: !isMobile,
    nav: true,
    mouseDrag: false,
    touchDrag: false,
    navText: [
      `<img src="${left}" alt="Prev" class="prev-button"/>`,
      `<img src="${left}" alt="Next" class="next-button"  />`,
    ],
  };

  useEffect(() => {
    if (!productDetail.product_gallery) return;
    const parsedImages = productDetail.product_gallery.map((item, index) => {
      return { alt: `ProductImage${index + 1}`, src: item };
    });
    setImagesArray(parsedImages);
  }, [productDetail.product_gallery]);

  const prevNextImage = (value) => {
    let index;
    if (value === "prev") {
      index = selectedImage > 0 ? selectedImage - 1 : 0;
    } else {
      index =
        selectedImage < imagesArray?.length - 1
          ? selectedImage + 1
          : imagesArray?.length - 1;
    }
    setSelectedImage(index);
  };

  const SelectedImageSrc = (item) => {
    let result;
    if (selectedImage) {
      if (productDetail.merchant_id) {
        result =
          mediaUrl + "products/gallery/" + imagesArray[selectedImage]?.src;
      } else {
        result = apiglobaltixMediaUrl + imagesArray[selectedImage]?.src;
      }
    } else {
      if (productDetail.merchant_id) {
        result = mediaUrl + "products/gallery/" + item.src;
      } else {
        result = apiglobaltixMediaUrl + item.src;
      }
    }
    return result;
  };

  const prevNextButton = (value) => {
    if (imagesArray.length < 2) return null;
    return (
      <img
        className={`image-gallery-main__fullscreen__${value}-btn`}
        onClick={() => {
          prevNextImage(value);
        }}
        src={left}
        alt={`${value}-button`}
      />
    );
  };

  return (
    <>
      {open && (
        <div className="image-gallery-main">
          <div
            onClick={handleClose}
            className="image-gallery-main__closebutton"
          >
            <img src={galleryclose} alt="closeIcon" />
          </div>
          <div className="image-gallery-main__fullscreen">
            {prevNextButton("prev")}
            <OwlCarousel options={carousel}>
              {imagesArray?.map((item, index) => {
                return (
                  <img
                    className="carousel-img"
                    key={index}
                    src={SelectedImageSrc(item)}
                    alt={"gallery"}
                  />
                );
              })}
            </OwlCarousel>
            {showGalleryFor !== "ttdOnly" &&
              imagesArray?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="image-gallery-main__fullscreen__content"
                  >
                    <p>
                      {selectedImage !== ""
                        ? imagesArray[selectedImage]?.alt
                        : item.alt}
                    </p>
                    <span>
                      {`${
                        selectedImage !== "" &&
                        selectedImage < imagesArray?.length
                          ? selectedImage + 1
                          : imagesArray?.length
                      }/${imagesArray?.length}`}
                    </span>
                  </div>
                );
              })}
            {prevNextButton("next")}
          </div>
          <div className="image-gallery-main__smallscreen">
            {imagesArray?.map((item, index) => {
              return (
                <img
                  className={selectedImage === index ? "selected_image" : ""}
                  key={index}
                  onClick={() => {
                    setSelectedImage(index);
                  }}
                  src={
                    productDetail.merchant_id
                      ? mediaUrl + "products/gallery/" + item.src
                      : apiglobaltixMediaUrl + item.src
                  }
                  alt={"gallery"}
                />
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default ImageGalleryPopup;
